<template>
	<v-dialog v-model="dialog" width="500">
		<v-card>
			<v-card-title class="headline grey lighten-2" primary-title>
				Activar notificaciones
			</v-card-title>

			<v-card-text>
				{{ text }}
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					color="primary"
					flat
					@click="dialog = false"
					v-if="okText !== 'Cerrar'"
				>
					No
				</v-btn>
				<v-btn color="primary" flat @click="handleSub"> {{ okText }} </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import api from './api/apibackend';
export default {
	data() {
		return {
			text: "Quieres recibir notificaciones en este dispositivo?",
			okText: "Recibir notificaciones",
			applicationServerPublicKey:
				"BC4auUyTyASkAy-ir6di0RZirzu1dWkN-lu6z6S1Yd-rCVhyNgWykgcGxn33mZzui1RDt5s9sbefJszAUfxNXuQ",
			SERVER_URL: process.env.VUE_APP_BASE_URL + "store/admin_subscription",
			swRegistration: null,
			dialog: false,
		};
	},
	mounted() {
		if (
			this.roleUser === 2 /*client role = 2*/ &&
			Notification.permission !== "denied"
		) {
			this.check();
		}
	},
	methods: {
		urlB64ToUint8Array(base64String) {
			const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
			const base64 = (base64String + padding)
				.replace(/-/g, "+")
				.replace(/_/g, "/");

			const rawData = window.atob(base64);
			const outputArray = new Uint8Array(rawData.length);

			for (let i = 0; i < rawData.length; ++i) {
				outputArray[i] = rawData.charCodeAt(i);
			}
			return outputArray;
		},
		check() {
			if ("serviceWorker" in navigator && "PushManager" in window) {
				console.log("Service Worker and Push is supported");
				navigator.serviceWorker
					.register("clientWebPush.js")
					.then((reg) => {
						console.log("Service Worker is registered");
						this.swRegistration = reg;
						reg.onupdatefound = function() {
							// The updatefound event implies that reg.installing is set; see
							// https://w3c.github.io/ServiceWorker/#service-worker-registration-updatefound-event
							var installingWorker = reg.installing;

							installingWorker.onstatechange = function() {
								switch (installingWorker.state) {
									case "installed":
										if (navigator.serviceWorker.controller) {
											// At this point, the old content will have been purged and the fresh content will
											// have been added to the cache.
											// It's the perfect time to display a "New content is available; please refresh."
											// message in the page's interface.
											console.log("New or updated content is available.");
										} else {
											// At this point, everything has been precached.
											// It's the perfect time to display a "Content is cached for offline use." message.
											console.log("Content is now available offline!");
										}
										break;

									case "redundant":
										console.error(
											"The installing service worker became redundant."
										);
										break;
								}
							};
						};

						this.swCheck();
					})
					.catch(function(error) {
						console.error("Service Worker Error", error);
					});
			} else {
				console.warn("Push messaging is not supported");
			}
		},
		saveSubscriptionOnServer(subscription) {
			api.post(this.SERVER_URL, subscription
			)
				.then((res) => console.log(res))
				.catch((err) => console.log(err));
		},
		subscribeUser(swRegistration) {
			const applicationServerKey = this.urlB64ToUint8Array(
				this.applicationServerPublicKey
			);
			swRegistration.pushManager
				.subscribe({
					userVisibleOnly: true,
					applicationServerKey: applicationServerKey,
				})
				.then((subscription) => {
					this.saveSubscriptionOnServer(subscription);
					this.close();
				})
				.catch((err) => {
					this.text =
						"Haz rechazado los permisos de notificaciones en este dispositivo.";
					this.okText = "Cerrar";
					console.log("Failed to subscribe the user: ", err);
				});
		},
		swCheck() {
			this.swRegistration.pushManager.getSubscription().then((subscription) => {
				if (subscription === null) {
					this.dialog = true;
				}
			});
		},
		handleSub() {
			if (Notification.permission == "denied") {
				this.close();
			}
			this.subscribeUser(this.swRegistration);
		},
		close() {
			this.dialog = false;
		},
	},
	computed: {
		roleUser() {
			let userData = JSON.parse(localStorage.getItem("userData"));
			return userData.role_id;
		},
	},
};
</script>
